// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1QmzP","row":"styles_row__2pIFQ"};